import Vue from 'vue';
import VueI18n from 'vue-i18n';
import store from './store';

// Import locale files
import pt from './locales/pt.json';
import en from './locales/en.json';
import es from './locales/es.json';
import it from './locales/it.json';
import de from './locales/de.json';
import fr from './locales/fr.json';

Vue.use(VueI18n);

const messages = {
  pt,
  en,
  es,
  it,
  de,
  fr,
};

// Get the user's language from the store or fallback to 'pt'
function getLocale() {
  const userLanguage = store.state.user.language;

  // If user language is set in store, use it
  if (userLanguage && messages[userLanguage]) {
    return userLanguage;
  }

  // Fallback to browser language
  const browserLanguage = navigator.language.split('-')[0];
  if (messages[browserLanguage]) {
    return browserLanguage;
  }

  // Final fallback to Portuguese
  return 'pt';
}

const i18n = new VueI18n({
  locale: getLocale(),
  fallbackLocale: 'pt',
  messages,
  silentTranslationWarn: true,
});

// Watch for language changes in the store
store.watch(
  (state) => state.user.language,
  (newLanguage) => {
    if (newLanguage && messages[newLanguage]) {
      i18n.locale = newLanguage;
    }
  }
);

export default i18n;
